export const getSaleWithCustomer = /* GraphQL */ `
    query GetSaleWithCustomer($id: ID!) {
      getSale(id: $id) {
        id
        firstname
        lastname
        branch
        customers(limit: 10000){
          items {
            id
            customer {
              id
              basketID
              firstname
              lastname
              email
              phone_number
              address {
                items {
                  id
                  customerID
                  address
                  district
                  email
                  firstname
                  lastname
                  name
                  phone
                  postcode
                  subDistrict
                  province
                  location {
                      lat
                      lng
                  }
                  createdAt
                  updatedAt
                }
              }
            }
          }
        }
      }
    }
`;

export const getSaleWithCustomerWithAddress = /* GraphQL */ `
    query GetSaleWithCustomer($id: ID!) {
      getSale(id: $id) {
        id
        firstname
        lastname
        customers {
          items {
            customer {
              id
              basketID
              firstname
              lastname
              address { 
                items {
                  id
                  customerID
                  address
                  district
                  email
                  firstname
                  lastname
                  name
                  phone
                  postcode
                  subDistrict
                  province
                  location {
                      lat
                      lng
                  }
                  createdAt
                  updatedAt
                }
              }
            }
          }
        }
      }
    }
`;
export const saleStatByGranularityWithTimestamp = /* GraphQL */ `
  query SaleStatByGranularityWithTimestamp(
    $granularity: Granularity!
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSaleStatFilterInput
    $limit: Int
    $nextToken: String
  ) {
    saleStatByGranularityWithTimestamp(
      granularity: $granularity
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        timestamp
        granularity
        totalSaleVolume
        totalOrder
        totalCustomer
        createdAt
        updatedAt
        sale{
          id
          username
          firstname
          lastname
          branch
        }
      }
      nextToken
    }
  }
`;

export const customerStatByGranularityWithTimestamp = /* GraphQL */ `
  query CustomerStatByGranularityWithTimestamp(
    $granularity: Granularity!
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerStatFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerStatByGranularityWithTimestamp(
      granularity: $granularity
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        timestamp
        granularity
        totalSaleVolume
        totalOrder
        productList
        orderList
        createdAt
        updatedAt
        customer {
          id
          email
          phone_number
          firstname
          lastname
          address {
            items {
              id
              firstname
              lastname
              name
              address
              subDistrict
              district
              province
              postcode
              phone
            }
          }
        }
      }
      nextToken
    }
  }
`;